var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ud-ratio"},[_c('div',{staticClass:"ud-ratio-bg",style:({
    backgroundImage: 'url(' + _vm.src + ')', 
    paddingBottom: _vm.height + '%', 
    borderRadius: _vm.radius,
    backgroundSize: _vm.bgSize
  })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }